module["exports"] = [
  "Česká republika"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/cz/address/default_country.js
// module id = 202
// module chunks = 0